import { mustBeHTMLElement, mustBeHTMLElementOfType, KeyCodes } from "silver";

export class HeaderFlyout {

	private readonly dismissClick: (e: Event) => any;

	constructor(
		private trigger: HTMLElement,
		private flyout: HTMLElement
	) {
		if (!flyout.id) {
			throw new Error("Flyout is missing ID");
		}
		trigger.addEventListener("click", () => {
			this.open = !this.open;
		});
		this.dismissClick = (e: Event) => {
			if (e.target === this.flyout) { // clicked on the shade
				this.open = false;
			}
		};

		flyout.addEventListener("keyup", e => {
			if (e.keyCode === KeyCodes.ESC) {
				this.open = false;
				this.trigger.focus();
			}
		});

		[flyout, trigger].forEach(el => el.addEventListener("focusout", e => {
			if (e.relatedTarget instanceof Node && !this.isFlyoutNode(e.relatedTarget)) {
				this.open = false;
			}
		}));

		trigger.setAttribute("aria-controls", flyout.id);
		trigger.setAttribute("aria-expanded", this.open ? "true" : "false");
	}

	private isFlyoutNode(node: Node): boolean {
		return this.flyout.contains(node) || this.trigger === node;
	}

	public get open(): boolean {
		return this.flyout.classList.contains("-selected");
	}

	public set open(value: boolean) {
		if (value === this.open) {
			return;
		}
		if (value) {
			this.flyout.addEventListener("click", this.dismissClick);
		} else {
			this.flyout.removeEventListener("click", this.dismissClick);
		}
		this.flyout.classList.toggle("-selected", value);
		this.trigger.classList.toggle("-selected", value);
		this.trigger.setAttribute("aria-expanded", value ? "true" : "false");
	}

	public static initDocument(document: Document): void {
		Array.from(document.querySelectorAll(".headerFlyout"))
			.forEach(flyout => (new HeaderFlyout(
				mustBeHTMLElementOfType(document.querySelector(`button[data-submenu=${flyout.id}]`), "button"),
				mustBeHTMLElement(flyout)
			)));
	}

}
